import React from 'react';
import classNames from 'classnames';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import { ColorPopover } from '../../../../components/Popover/ColorPopover';
import { BaseInputProps } from './BaseInput';
import { Color } from '../../../../types/graphqlTypes';
import { hexToColor, colorToHex, isColor } from '../../../../utils/colorUtils';
import { useT } from '../../../../translation/src';

export const ColorInput: React.FC<BaseInputProps<string>> = ({ instance, onChange, disabled = false, className }) => {
  const { config, value } = instance;
  const differentValuesText = useT('different values selected', { swc: true });

  // Ensure we have a valid color object
  let currentColor: Color;
  if (typeof value === 'string') {
    currentColor = hexToColor(value);
  } else if (isColor(value)) {
    currentColor = value;
  } else {
    console.warn('Invalid color value:', value, 'using default');
    currentColor = { r: 0, g: 0, b: 0, a: 1 };
  }

  const handleColorChange = (color: Color) => {
    onChange(colorToHex(color));
  };

  return (
    <div className={classNames('flex w-full items-center', className)}>
      <div className="relative w-full">
        <ColorPopover wide value={currentColor} onChange={handleColorChange} disabled={disabled || config.disabled} />
        {instance.isMixed && (
          <div className="pointer-events-none absolute inset-0 z-20 flex items-center justify-center rounded bg-white/80" title={differentValuesText}>
            <QuestionMarkCircleIcon className="h-4 w-4 text-neon-green-500" />
          </div>
        )}
      </div>
    </div>
  );
};
